import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
export var DropDownIndicatore = function () {
    React.useEffect(function () { }, []);
    return (_jsx("img", { src: "".concat(process.env.IMG_URL, "/static/vendors/images/icons/chevron-down-blue.svg"), alt: "arrow down" }));
};
